export const iAmRadios = [
  {
    id: 1,
    type: 'radio',
    name: 'who',
    text: 'Architekt indywidualny',
  },
  {
    id: 2,
    type: 'radio',
    name: 'who',
    text: 'Biuro architektoniczne',
  },
];
